<template lang="pug">
    v-dialog( persistent max-width="1250px" v-model="open" )
        v-toolbar( color="primary" dark sticky flat )
            v-toolbar-title Creación cuenta contable
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-layout( row wrap )
            crud-form(:fields="fields" ref="refCFCreateAccount" submitText="Crear" @submitForm="submitCreateAccount")
</template>

<script>
//-
import { CrudForm } from '@/components/reusable_components'
import { mapActions, mapState } from 'vuex'
import FieldsCreateAccount from './FieldsCreateAccount'
import {
    fetchAllParents,
    getAllAccountTypes,
    createAccounts,
    findByCode,
} from '@/services/api/account'
//-
export default {
    name: 'dialog-create-account',
    // props: {},
    data: function() {
        return {
            open: false,
            fields: FieldsCreateAccount,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- Close modal
        toggleOpen: function() {
            this.open = !this.open
            this.resetForm()
        },
        // -- Reset form
        resetForm: function() {
            this.fields = [...this.fields]
        },
        // -- Submit & Confirmations
        submitCreateAccount: function() {
            this.resetSnackbarState()
            let vmodels = this.$refs.refCFCreateAccount.vmodels
            if(vmodels.code !== "" && vmodels.comment !== "" && !isNaN(vmodels.acc_account_type_id)){
                this.setMessageConfirmSnack('Crear')
                let payload = this.fillSnack(
                    'warning',
                    '¿Desea crear cuenta contable?',
                    ''
                )
                this.initSnackbar(payload)
            }
            else{
                this.showSnackbar( 'info', 'Complete datos faltantes', '' )
            }
        },
        // -- Other functions
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        setFieldOptionsData(index, data) {
            this.fields[index].options.data = data
        },
        // -- Fetch data
        getInfo: async function() {
            let allParents = await fetchAllParents()
            let allTypes = await getAllAccountTypes()
            this.setFieldOptionsData(0, allTypes.data)
            this.setFieldOptionsData(1, allParents.data)
        },
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        open(val) {
            if (val == true) {
                this.getInfo()
            }
        },
        async responseConfirm(val) {
            //-
            if (val === 'Crear') {
                this.resetSnackbarState()
                let obj = {}
                obj.code = this.$refs.refCFCreateAccount.vmodels.code
                obj.comment = this.$refs.refCFCreateAccount.vmodels.comment
                obj.acc_account_type_id = this.$refs.refCFCreateAccount.vmodels.acc_account_type_id
                obj.acc_parent_id = isNaN(
                    this.$refs.refCFCreateAccount.vmodels.acc_parent_id
                )
                    ? null
                    : this.$refs.refCFCreateAccount.vmodels.acc_parent_id
                //-
                let validateExist = await findByCode(obj.code)
                if(validateExist.total > 0){
                    this.showSnackbar( 'warning', 'Acción inválida', 'Código ingresado ya se encuentra registrado')
                }
                else {
                    let response = await createAccounts(obj)
                    if (response.status == 'success') {
                        let payload = this.fillSnack(
                            'success',
                            'Cuenta contable creada con éxito',
                            ''
                        )
                        this.initSnackbar(payload)
                        this.$emit('success')
                        this.toggleOpen()
                    } else {
                        let payload = this.fillSnack(
                            'error',
                            'Error',
                            response.error
                        )
                        this.initSnackbar(payload)
                    }
                }
            }
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>